export default __webpack_public_path__ + "static/media/Samsung Electronics.f657d25f.png";